import React from 'react';

const About = () => {
 return (
<h1>It WORKS!<br/>Created by KAV</h1>
 );
};

export default About;